import {DESKTOP_MIN_WIDTH} from '../../constants/visuals';

export const DEVICE_KINDS = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
};

/**
 * С какого устройства зашли — в терминах интерфейса, а не операционной системы.
 *
 * Порог тот же, по которому меню и игровое поле выбирают раскладку
 * (DESKTOP_MIN_WIDTH), поэтому метка отвечает на вопрос «что человек реально
 * увидел», а не «какая у него ОС». Платформу (ios/android/windows/mac_osx)
 * GameAnalytics и так пишет к каждому событию сам — дублировать ее смысла нет.
 *
 * @returns {'mobile' | 'desktop'}
 */
export const getDeviceKind = () => {
  if (typeof window === 'undefined') {
    return DEVICE_KINDS.DESKTOP;
  }
  // innerWidth бывает нулевым там, где страница отрисована вне экрана
  // (headless-окружения, offscreen-панели) — в этом случае ширину берем у
  // документа, иначе метка врала бы «мобильный» на любой машине
  const width = window.innerWidth || document.documentElement?.clientWidth || 0;
  return width >= DESKTOP_MIN_WIDTH ? DEVICE_KINDS.DESKTOP : DEVICE_KINDS.MOBILE;
};
